const images = {
    start() {
        const d = new Date();
        $("[data-design]").each(function () {
            const _this = $(this);
            $.get(
                `https://${window.proofsDomain}shopify/images/?c=${window.storeCode}&d=${_this.data("design")}&i=${_this.data("productId")}&r=1&s=${_this.data("vendorSku")}`,
                function (url) {
                    if (url) {
                        if (_this.hasClass("img-built")) {
                            $(".img-built").prop(
                                "src",
                                `${url}?t=${d.getTime()}`
                            );
                        } else {
                            _this.prop("src", `${url}?t=${d.getTime()}`);
                        }
                    }
                }
            );
        });
    },
};
$(() => {
    images.start();
});